import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Type } from './branch';
import { Type } from '../type/type';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class TypeService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Type[]> {
    return this.httpClient.get<Type[]>(this.baseUrl + 'api/TypeApi')
  }
  Post(branch: Type): Observable<any> {

  
    return this.httpClient.post(this.baseUrl + 'api/TypeApi/Add', branch, { headers: header, observe: 'response' })
  }
  Delete(branch: Type) {
   
    return this.httpClient.post(this.baseUrl + 'api/TypeApi/activeordeactive', branch, { headers: header, observe: 'response' })
  }
  Put(branch: Type): Observable<any> {
    
    return this.httpClient.put(this.baseUrl + 'api/TypeApi/Update', branch, { headers: header, observe: 'response' })
  }


}



